export const SITE = {
    name: "COMPASSIA",
    domain: "https://compassia.es",
    email: "info@compassia.es",
    phone: "+34 600 000 000",
    city: "Barcelona",
    country: "España",
    tagline: "Optimización sin fricción",
    description:
        "Automatizamos y optimizamos procesos con tu stack actual. Pilotos de 2–4 semanas con objetivos medibles. Integraciones n8n, RAG privado en AWS, Leads/CRM, contratos y aprobaciones, onboarding/offboarding y reporting.",
    keywords:
        "automatización PYMES, n8n, RAG privado, AWS, NetSuite, integración ERP CRM, IA aplicada, dashboards KPIs, gestión de agenda, clasificación de leads, firma electrónica, aprobaciones, onboarding, reporting, proyectos a medida",
    ogImage: "/og-compassia.jpg",
    twitter: "@compassia",
};